import { CustomComponentProps } from "utils/types/generalTypes";
import SVG from "../core/SVG";
import { Link } from "react-router-dom";

export type SettingsItemProps = CustomComponentProps & {
    svg: string;
    title: string;
    details: string;
    link: string;
};

const SettingsItem = ({
    svg,
    title,
    details,
    link,
    className,
    style
}: SettingsItemProps) => {
    return (
        <Link
            to={link}
            className={`settings-item d-flex flex-j-start w-full flex-a-center gap-10 pt-20 pl-10 pr-10 w-full ${className}`}
            style={style}
        >
            <SVG svg={svg} size={24} style={{ minWidth: "25px" }} />
            <div className="settings-item-text d-flex flex-j-center flex-a-start flex-col gap-5">
                <span className="settings-h2 fw-500 black-text white-text">
                    {title}
                </span>
                <span className="settings-detail momeento-p grey-text">
                    {details}
                </span>
            </div>
            <SVG
                svg="chevron-right"
                size={24}
                className="ml-auto"
                style={{ minWidth: "25px" }}
            />
        </Link>
    );
};

export default SettingsItem;
